// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-year-switcher {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-2-font-size);
  line-height: var(--g-text-subheader-2-line-height);
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 32px;
  border-radius: 20px;
  color: var(--g-color-text-secondary);
  background-color: var(--g-color-base-background);
  box-shadow: 0 2px 4px 0 var(--g-color-sfx-shadow-heavy);
  opacity: 0.9;
  z-index: 1;
}
.dl-datepicker-year-switcher__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  opacity: 0.85;
  cursor: pointer;
}
.dl-datepicker-year-switcher__arrow_left {
  left: 5px;
}
.dl-datepicker-year-switcher__arrow_right {
  right: 5px;
}
.dl-datepicker-year-switcher__arrow_left .g-icon {
  transform: rotate(180deg) translateY(1px);
}
.dl-datepicker-year-switcher__arrow:hover {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/YearSwitcher/YearSwitcher.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAEA;ECoOI,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;EDrOA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oCAAA;EACA,gDAAA;EACA,uDAAA;EACA,YAAA;EACA,UAAA;AAEJ;AAAI;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAER;AAAQ;EACI,SAAA;AAEZ;AACQ;EACI,UAAA;AACZ;AAEQ;EACI,yCAAA;AAAZ;AAGQ;EACI,UAAA;AADZ","sourcesContent":[".dl-datepicker-year-switcher {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-2-font-size);\n  line-height: var(--g-text-subheader-2-line-height);\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 80px;\n  height: 32px;\n  border-radius: 20px;\n  color: var(--g-color-text-secondary);\n  background-color: var(--g-color-base-background);\n  box-shadow: 0 2px 4px 0 var(--g-color-sfx-shadow-heavy);\n  opacity: 0.9;\n  z-index: 1;\n}\n.dl-datepicker-year-switcher__arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  opacity: 0.85;\n  cursor: pointer;\n}\n.dl-datepicker-year-switcher__arrow_left {\n  left: 5px;\n}\n.dl-datepicker-year-switcher__arrow_right {\n  right: 5px;\n}\n.dl-datepicker-year-switcher__arrow_left .g-icon {\n  transform: rotate(180deg) translateY(1px);\n}\n.dl-datepicker-year-switcher__arrow:hover {\n  opacity: 1;\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
